import { ReviewTab } from '@/features/leads/components/Detail/Tabs/ReviewTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/review')({
  component: ReviewTab,
});
